// extracted by mini-css-extract-plugin
module.exports = {"container":"permissionGroup_container__25wne","label":"permissionGroup_label__1g8jY","actions":"permissionGroup_actions__2obhY","checkBox":"permissionGroup_checkBox__3JYhk"};